import React from "react";
import { connect } from "dva"
import { framework_tool, component_tool, utils_tool } from "@/tool"

import moment from "moment";
import { readRecordColumns, likeRecordColumns, downLoadRecordColumns,collectRecordColumns,commentRecordColumns } from './allColumns'
import { readExcelColumns, readUserIdentityExcelColumns ,commentExcelColumns,commentUserIdentityExcelColumns} from './exportColumns'

let { WizContainer, modelUtils } = framework_tool
let { WizSpin, WizButton, WizInput, WizRow, WizCol, WizTabs, WizAlert, WizModal, WizForm, WizCard, WizSearchBar, WizDataTable, WizBrowserExport } = component_tool
let { TabPane } = WizTabs
let { getPageData, Session } = utils_tool;
const { TextArea } = WizInput;


const getParamRecord = (history) => {
  let record = {}
  if (history.location && history.location.pathname === "/proKnowledge/knowledgeBaseList/knowledgeRecordList") {
    if (history.location.record) {
      record = history.location.record
      Session.set('knowledgeInfo', record);
    } else {
      record = Session.get('knowledgeInfo') || {}
    }
  }
  return record
}

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}

export class KnowledgeRecodList extends WizContainer {
  componentName = 'knowledgeRecodList'

  constructor(props) {
    super(props);
    const { history } = props;
    this.knowledgeInfo = getParamRecord(history)
    this.state = {
      knowledgeActivityKey: "1",
      time: new Date().getTime(),
      searchParams : {proKnowledgeId:this.knowledgeInfo.id,type:1},
      replyModalVisible : false,
      commentId : undefined,
      replyPerson: undefined,
      content:undefined,
    }
    this.btnCode = this.getMenuBtn() || [];
  }

  _componentDidMount() {
    this._getReadRecordList({ type: 1, proKnowledgeId: this.knowledgeInfo.id });
  }


  _getReadRecordList(apiParams = {}) {
    this.doAction(
      {
        path: 'proKnowledgeRecord/pageList',
        payload: {
          key: 'proKnowledgeRecord@pageList' + apiParams.type,
          apiParams: {
            ...apiParams
          }
        }
      }
    )
  }

  _exportRecordList(apiParams = {}) {
    this.doAction(
      {
        path: 'proKnowledgeRecord/export',
        payload: {
          key: 'proKnowledgeRecord@export' + apiParams.type,
          apiParams: {
            ...apiParams
          }
        }
      }
    )
  }

  _exportRecordByUserIdentity(apiParams = {}) {
    this.doAction(
      {
        path: 'proKnowledgeRecord/exportByUserIdentity',
        payload: {
          key: 'proKnowledgeRecord@exportByUserIdentity' + apiParams.type,
          apiParams: {
            ...apiParams
          }
        }
      }
    )
  }

  _getCollectRecordList(apiParams = {}) {
    this.doAction(
      {
        path: 'proKnowledgeRecord/collectPageList',
        payload: {
          key: 'proKnowledgeRecord@collectPageList',
          apiParams: {
            ...apiParams
          }
        }
      }
    )
  }

  _exportCollectRecordList(apiParams = {}) {
    this.doAction(
      {
        path: 'proKnowledgeRecord/collectExport',
        payload: {
          key: 'proKnowledgeRecord@collectExport',
          apiParams: {
            ...apiParams
          }
        }
      }
    )
  }

  _exportCollectRecordByUserIdentity(apiParams = {}) {
    this.doAction(
      {
        path: 'proKnowledgeRecord/collectExportByUserIdentity',
        payload: {
          key: 'proKnowledgeRecord@collectExportByUserIdentity',
          apiParams: {
            ...apiParams
          }
        }
      }
    )
  }

  _getCommentRecordList(apiParams = {}) {
    this.doAction(
      {
        path: 'proKnowledgeRecord/commentPageList',
        payload: {
          key: 'proKnowledgeRecord@commentPageList',
          apiParams: {
            ...apiParams
          }
        }
      }
    )
  }

  _exportCommentRecordList(apiParams = {}) {
    this.doAction(
      {
        path: 'proKnowledgeRecord/commentExport',
        payload: {
          key: 'proKnowledgeRecord@commentExport',
          apiParams: {
            ...apiParams
          }
        }
      }
    )
  }

  _exportCommentRecordByUserIdentity(apiParams = {}) {
    this.doAction(
      {
        path: 'proKnowledgeRecord/commentExportByUserIdentity',
        payload: {
          key: 'proKnowledgeRecord@commentExportByUserIdentity',
          apiParams: {
            ...apiParams
          }
        }
      }
    )
  }

  _changeTop(id,state) {
    WizModal.confirm({
      title: "注意",
      content: `您确定要${state === 1 ? "置顶" : "取消置顶"}该评论吗？`,
      onOk: () => {
        this.doAction({
          path: 'comment/changeTop',
          payload: {
            key: 'comment@changeTop',
            apiParams:{
              id
            },
          }
        });
      },
      onCancel() { },
    });
  }

  _changeScreen(id,state) {
    WizModal.confirm({
      title: "注意",
      content: `您确定要${state === 3 ? "取消屏蔽" : "屏蔽"}该评论吗？`,
      onOk: () => {
        this.doAction({
          path: "comment/changeScreen",
          payload: {
            key: "comment@changeScreen",
            apiParams:{
              id
            },
          },
        });
      },
      onCancel() { },
    });
  }

  _commentAdd() {
    this.doAction({
      path: "comment/commentAdd",
      payload: {
        key: "comment@commentAdd",
        apiParams:{
          commentId : this.state.commentId,
          commentType : 1,
          replyPerson : this.state.replyPerson,
          bizId : this.knowledgeInfo.id,
          bizType : 58,
          content: this.state.content,
        },
      },
    });
  }
  

  propsAndStateOnChange = {
    proKnowledgeRecordReadExport : this._proKnowledgeRecordReadExportOver.bind(this),
    proKnowledgeRecordLikeExport : this._proKnowledgeRecordLikeExportOver.bind(this),
    proKnowledgeRecordDownLoadExport : this._proKnowledgeRecordDownLoadExportOver.bind(this),
    readExportUserIdentity : this._readExportUserIdentityOver.bind(this),
    likeExportUserIdentity : this._likeExportUserIdentityOver.bind(this),
    downLoadExportUserIdentity : this._downLoadExportUserIdentityOver.bind(this),
    collectExport : this._collectExportOver.bind(this),
    collectExportByUserIdentity : this._collectExportByUserIdentityOver.bind(this),
    commentExport : this._commentExportOver.bind(this),
    commentExportByUserIdentity : this._commentExportByUserIdentityOver.bind(this),
    changeTop:this._changeTopOver.bind(this),
    changeScreen:this._changeScreenOver.bind(this),
    commentAdd : this._commentAddOver.bind(this),
  }

  _commentAddOver(nextProps, nextState, key) {
    let o = nextProps.commentAdd
    if (o['success']) {
      nextState.commentId = undefined;
      nextState.replyPerson = undefined;
      nextState.replyModalVisible = false;
      nextState.content = undefined;
      wizNotice.success(o['msg'])
      this._getCommentRecordList(this.state.searchParams)
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _changeTopOver(nextProps, nextState, key) {
    let o = nextProps.changeTop
    if (o['success']) {
      wizNotice.success(o['msg'])
      this._getCommentRecordList(this.state.searchParams)
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _changeScreenOver(nextProps, nextState, key) {
    let o = nextProps.changeScreen
    if (o['success']) {
      wizNotice.success(o['msg'])
      this._getCommentRecordList(this.state.searchParams)
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _proKnowledgeRecordReadExportOver(nextProps, nextState, key) {
    let o = nextProps.proKnowledgeRecordReadExport
    let columnDefs = readExcelColumns(1)
    let record = this.knowledgeInfo;
    if (o['success']) {
      let data = o['data']
      let title = '标题: ' + record.title + '\n'
        + '分类: ' + record.categoryStr + '\n'
        + '标签: ' + record.labelStr + '\n'
        + '生效时间: ' + record.effectiveTime + '\n'
        + '失效时间: ' + record.failureTime + '\n'
        + '发布平台: ' + record.releasePlatformStr
      WizBrowserExport({
        title: title,
        sheetName: '阅读记录',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '阅读记录.xlsx',
        titleParams: {
          alignment: { vertical: 'bottom', horizontal: 'left', wrapText: true },
          style: {
            alignment: { vertical: "bottom", horizontal: "left", wrapText: true },
          },
          font: {},
        },
        titleRow: {
          height: 90
        }
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _proKnowledgeRecordLikeExportOver(nextProps, nextState, key) {
    let o = nextProps.proKnowledgeRecordLikeExport
    let columnDefs = readExcelColumns(2)
    let record = this.knowledgeInfo;
    if (o['success']) {
      let data = o['data']
      let title = '标题: ' + record.title + '\n'
        + '分类: ' + record.categoryStr + '\n'
        + '标签: ' + record.labelStr + '\n'
        + '生效时间: ' + record.effectiveTime + '\n'
        + '失效时间: ' + record.failureTime + '\n'
        + '发布平台: ' + record.releasePlatformStr
      WizBrowserExport({
        title: title,
        sheetName: '点赞记录',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '点赞记录.xlsx',
        titleParams: {
          alignment: { vertical: 'bottom', horizontal: 'left', wrapText: true },
          style: {
            alignment: { vertical: "bottom", horizontal: "left", wrapText: true },
          },
          font: {},
        },
        titleRow: {
          height: 90
        }
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _proKnowledgeRecordDownLoadExportOver(nextProps, nextState, key) {
    let o = nextProps.proKnowledgeRecordDownLoadExport
    let columnDefs = readExcelColumns(3)
    let record = this.knowledgeInfo;
    if (o['success']) {
      let data = o['data']
      let title = '标题: ' + record.title + '\n'
        + '分类: ' + record.categoryStr + '\n'
        + '标签: ' + record.labelStr + '\n'
        + '生效时间: ' + record.effectiveTime + '\n'
        + '失效时间: ' + record.failureTime + '\n'
        + '发布平台: ' + record.releasePlatformStr
      WizBrowserExport({
        title: title,
        sheetName: '下载记录',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '下载记录.xlsx',
        titleParams: {
          alignment: { vertical: 'bottom', horizontal: 'left', wrapText: true },
          style: {
            alignment: { vertical: "bottom", horizontal: "left", wrapText: true },
          },
          font: {},
        },
        titleRow: {
          height: 90
        }
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _collectExportOver(nextProps, nextState, key) {
    let o = nextProps.collectExport
    let columnDefs = readExcelColumns(4)
    let record = this.knowledgeInfo;
    if (o['success']) {
      let data = o['data']
      let title = '标题: ' + record.title + '\n'
        + '分类: ' + record.categoryStr + '\n'
        + '标签: ' + record.labelStr + '\n'
        + '生效时间: ' + record.effectiveTime + '\n'
        + '失效时间: ' + record.failureTime + '\n'
        + '发布平台: ' + record.releasePlatformStr
      WizBrowserExport({
        title: title,
        sheetName: '收藏记录',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '收藏记录.xlsx',
        titleParams: {
          alignment: { vertical: 'bottom', horizontal: 'left', wrapText: true },
          style: {
            alignment: { vertical: "bottom", horizontal: "left", wrapText: true },
          },
          font: {},
        },
        titleRow: {
          height: 90
        }
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _commentExportOver(nextProps, nextState, key) {
    let o = nextProps.commentExport
    let columnDefs = commentExcelColumns()
    let record = this.knowledgeInfo;
    if (o['success']) {
      let data = o['data']
      let title = '标题: ' + record.title + '\n'
        + '分类: ' + record.categoryStr + '\n'
        + '标签: ' + record.labelStr + '\n'
        + '生效时间: ' + record.effectiveTime + '\n'
        + '失效时间: ' + record.failureTime + '\n'
        + '发布平台: ' + record.releasePlatformStr
      WizBrowserExport({
        title: title,
        sheetName: '评论记录',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '评论记录.xlsx',
        titleParams: {
          alignment: { vertical: 'bottom', horizontal: 'left', wrapText: true },
          style: {
            alignment: { vertical: "bottom", horizontal: "left", wrapText: true },
          },
          font: {},
        },
        titleRow: {
          height: 90
        }
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _readExportUserIdentityOver(nextProps, nextState, key) {
    let o = nextProps.readExportUserIdentity
    let columnDefs = readUserIdentityExcelColumns(1)
    let record = this.knowledgeInfo;
    if (o['success']) {
      let data = o['data']
      let title = '标题: ' + record.title + '\n'
        + '分类: ' + record.categoryStr + '\n'
        + '标签: ' + record.labelStr + '\n'
        + '生效时间: ' + record.effectiveTime + '\n'
        + '失效时间: ' + record.failureTime + '\n'
        + '发布平台: ' + record.releasePlatformStr
      WizBrowserExport({
        title: title,
        sheetName: '阅读记录按任职导出',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '阅读记录按任职导出.xlsx',
        titleParams: {
          alignment: { vertical: 'bottom', horizontal: 'left', wrapText: true },
          style: {
            alignment: { vertical: "bottom", horizontal: "left", wrapText: true },
          },
          font: {},
        },
        titleRow: {
          height: 90
        }
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _likeExportUserIdentityOver(nextProps, nextState, key) {
    let o = nextProps.likeExportUserIdentity
    let columnDefs = readUserIdentityExcelColumns(2)
    let record = this.knowledgeInfo;
    if (o['success']) {
      let data = o['data']
      let title = '标题: ' + record.title + '\n'
        + '分类: ' + record.categoryStr + '\n'
        + '标签: ' + record.labelStr + '\n'
        + '生效时间: ' + record.effectiveTime + '\n'
        + '失效时间: ' + record.failureTime + '\n'
        + '发布平台: ' + record.releasePlatformStr
      WizBrowserExport({
        title: title,
        sheetName: '点赞记录按任职导出',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '点赞记录按任职导出.xlsx',
        titleParams: {
          alignment: { vertical: 'bottom', horizontal: 'left', wrapText: true },
          style: {
            alignment: { vertical: "bottom", horizontal: "left", wrapText: true },
          },
          font: {},
        },
        titleRow: {
          height: 90
        }
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _downLoadExportUserIdentityOver(nextProps, nextState, key) {
    let o = nextProps.downLoadExportUserIdentity
    let columnDefs = readUserIdentityExcelColumns(3)
    let record = this.knowledgeInfo;
    if (o['success']) {
      let data = o['data']
      let title = '标题: ' + record.title + '\n'
        + '分类: ' + record.categoryStr + '\n'
        + '标签: ' + record.labelStr + '\n'
        + '生效时间: ' + record.effectiveTime + '\n'
        + '失效时间: ' + record.failureTime + '\n'
        + '发布平台: ' + record.releasePlatformStr
      WizBrowserExport({
        title: title,
        sheetName: '下载记录按任职导出',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '下载记录按任职导出.xlsx',
        titleParams: {
          alignment: { vertical: 'bottom', horizontal: 'left', wrapText: true },
          style: {
            alignment: { vertical: "bottom", horizontal: "left", wrapText: true },
          },
          font: {},
        },
        titleRow: {
          height: 90
        }
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _collectExportByUserIdentityOver(nextProps, nextState, key) {
    let o = nextProps.collectExportByUserIdentity
    let columnDefs = readUserIdentityExcelColumns(4)
    let record = this.knowledgeInfo;
    if (o['success']) {
      let data = o['data']
      let title = '标题: ' + record.title + '\n'
        + '分类: ' + record.categoryStr + '\n'
        + '标签: ' + record.labelStr + '\n'
        + '生效时间: ' + record.effectiveTime + '\n'
        + '失效时间: ' + record.failureTime + '\n'
        + '发布平台: ' + record.releasePlatformStr
      WizBrowserExport({
        title: title,
        sheetName: '收藏记录按任职导出',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '收藏记录按任职导出.xlsx',
        titleParams: {
          alignment: { vertical: 'bottom', horizontal: 'left', wrapText: true },
          style: {
            alignment: { vertical: "bottom", horizontal: "left", wrapText: true },
          },
          font: {},
        },
        titleRow: {
          height: 90
        }
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _commentExportByUserIdentityOver(nextProps, nextState, key) {
    let o = nextProps.commentExportByUserIdentity
    let columnDefs = commentUserIdentityExcelColumns()
    let record = this.knowledgeInfo;
    if (o['success']) {
      let data = o['data']
      let title = '标题: ' + record.title + '\n'
        + '分类: ' + record.categoryStr + '\n'
        + '标签: ' + record.labelStr + '\n'
        + '生效时间: ' + record.effectiveTime + '\n'
        + '失效时间: ' + record.failureTime + '\n'
        + '发布平台: ' + record.releasePlatformStr
      WizBrowserExport({
        title: title,
        sheetName: '评论记录按任职导出',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '评论记录按任职导出.xlsx',
        titleParams: {
          alignment: { vertical: 'bottom', horizontal: 'left', wrapText: true },
          style: {
            alignment: { vertical: "bottom", horizontal: "left", wrapText: true },
          },
          font: {},
        },
        titleRow: {
          height: 90
        }
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  changeTab = (e) => {
    let searchParams = {};
    if (e === "1") {
      searchParams = { type: 1, proKnowledgeId: this.knowledgeInfo.id }
      this._getReadRecordList(searchParams)
    } else if (e === "2") {
      searchParams = { type: 2, proKnowledgeId: this.knowledgeInfo.id }
      this._getReadRecordList(searchParams)
    } else if (e === "3") {
      searchParams = {proKnowledgeId: this.knowledgeInfo.id}
      this._getCommentRecordList(searchParams)
    } else if (e === "4") {
      searchParams = {proKnowledgeId: this.knowledgeInfo.id}
      this._getCollectRecordList(searchParams)
    } else if (e === "5") {
      searchParams = { type: 3, proKnowledgeId: this.knowledgeInfo.id }
      this._getReadRecordList(searchParams)
    }
    this.setState({
      time: new Date().getTime(),
      knowledgeActivityKey: e,
      searchParams:searchParams
    })
  }

  getBtn() {
    let btnList = [];
    switch(this.state.knowledgeActivityKey){
      case "1" : btnList = [
        <WizButton onClick={ ()=> this._exportRecordList(this.state.searchParams) }>导出</WizButton>,
      <WizButton onClick={ ()=> this._exportRecordByUserIdentity(this.state.searchParams) }>按任职导出</WizButton>
      ]
      break;
      case "2" : btnList = [
        <WizButton onClick={ ()=> this._exportRecordList(this.state.searchParams) }>导出</WizButton>,
      <WizButton onClick={ ()=> this._exportRecordByUserIdentity(this.state.searchParams) }>按任职导出</WizButton>
      ]
      break;
      case "3" : btnList = [
        <WizButton onClick={ ()=> this._exportCommentRecordList(this.state.searchParams) }>导出</WizButton>,
      <WizButton onClick={ ()=> this._exportCommentRecordByUserIdentity(this.state.searchParams) }>按任职导出</WizButton>
      ]
      break;
      case "4" : btnList = [
        <WizButton onClick={ ()=> this._exportCollectRecordList(this.state.searchParams) }>导出</WizButton>,
      <WizButton onClick={ ()=> this._exportCollectRecordByUserIdentity(this.state.searchParams) }>按任职导出</WizButton>
      ]
      break;
      case "5" : btnList = [
        <WizButton onClick={ ()=> this._exportRecordList(this.state.searchParams) }>导出</WizButton>,
      <WizButton onClick={ ()=> this._exportRecordByUserIdentity(this.state.searchParams) }>按任职导出</WizButton>
      ]
      break;
    }
    let btnsR = <WizButton.WizGroup>
      {btnList}
    </WizButton.WizGroup>
    return btnsR;
  }

  /**
   * 渲染操作按钮 且 进行权限检查
   */
  _renderBtn = () => {
    let type= this.state.knowledgeActivityKey
    let r = []
    let btns = new Map();
    btns.set('export',
      <WizButton
        key={'btn_export' + type}
        title="导出"
        type="export"
        onClick={() => {
          if (type === '1') {
            this._exportRecordList(this.state.searchParams)
          }
          if (type === '2') {
            this._exportRecordList(this.state.searchParams)
          }
          if (type === '3') {
            this._exportCommentRecordList(this.state.searchParams)
          }
          if (type === '4') {
            this._exportCollectRecordList(this.state.searchParams)
          }
          if (type === '5') {
            this._exportRecordList(this.state.searchParams) 
          }
        }}
        icon="export"
        style={{ marginBottom: 15 }}>导出</WizButton>
    );
    btns.set('batchExport',
      <WizButton
        key={'btn_batchExport' + type}
        title="按任职导出"
        type="export"
        onClick={() => {
          if (type === '1') {
            this._exportRecordByUserIdentity(this.state.searchParams)
          }
          if (type === '2') {
            this._exportRecordByUserIdentity(this.state.searchParams)
          }
          if (type === '3') {
            this._exportCommentRecordByUserIdentity(this.state.searchParams)
          }
          if (type === '4') {
            this._exportCollectRecordByUserIdentity(this.state.searchParams)
          }
          if (type === '5') {
            this._exportRecordByUserIdentity(this.state.searchParams) 
          }
        }}
        icon="export"
        style={{ marginBottom: 15 }}>按任职导出</WizButton>
    );
    
    this.btnCode.map(({ code }) => {
      if (btns.has(code)) {
        r.push(btns.get(code))
      }
    })
    return <WizButton.WizGroup>{r}</WizButton.WizGroup>
  }

  renderRecordList = () => {
    let { proKnowledgeRecordRead, proKnowledgeRecordLike,proKnowledgeRecordDownLoad,collectPageList,commentPageList, proKnowledgeRecordLoading,commentLoading } = this.props;
    let tableKey = this.state.knowledgeActivityKey;
    let columns;
    let pageList;
    switch(tableKey){
      case "1": 
       columns = readRecordColumns(this)
       pageList = getPageData(proKnowledgeRecordRead && proKnowledgeRecordRead.data)
        break;
        case "2": 
       columns = likeRecordColumns(this)
       pageList = getPageData(proKnowledgeRecordLike && proKnowledgeRecordLike.data)
        break;
        case "3": 
       columns = commentRecordColumns(this)
       pageList = getPageData(commentPageList && commentPageList.data)
        break;
        case "4": 
       columns = collectRecordColumns(this)
       pageList = getPageData(collectPageList && collectPageList.data)
        break;
        case "5": 
       columns = downLoadRecordColumns(this)
       pageList = getPageData(proKnowledgeRecordDownLoad && proKnowledgeRecordDownLoad.data)
        break;
    }
    
    let searchBarProps = {
      collapse: false,
      columns,
      record: { proKnowledgeId: this.knowledgeInfo.id },
      onSearch: values => {
        if(tableKey=='1'){
          values = { ...values, type: 1, proKnowledgeId: this.knowledgeInfo.id }
          this._getReadRecordList(values)
        }else if(tableKey=='2'){
          values = { ...values, type: 2, proKnowledgeId: this.knowledgeInfo.id }
          this._getReadRecordList(values)
        }else if(tableKey=='3'){
          values = { ...values, proKnowledgeId: this.knowledgeInfo.id }
          this._getCommentRecordList(values)
        }else if(tableKey=='4'){
          values = { ...values, proKnowledgeId: this.knowledgeInfo.id }
          this._getCollectRecordList(values)
        }else if(tableKey=='5'){
          values = { ...values, type: 3, proKnowledgeId: this.knowledgeInfo.id }
          this._getReadRecordList(values)
        }
        this.setState({
          searchParams : values
        })
      }
    }
    let dataTableProps = {
      loading: proKnowledgeRecordLoading || commentLoading,
      columns,
      rowKey: "id",
      dataItems: pageList,
      showNum: false,
      isScroll: true,
      onChange: ({ pageNum, pageSize }) => {
        values = { current: pageNum, size: pageSize, ...this.state.searchParams}
        if(tableKey=='1'){
          this._getReadRecordList(values)
        }else if(tableKey=='2'){
          this._getReadRecordList(values)
        }else if(tableKey=='3'){
          this._getCommentRecordList(values)
        }else if(tableKey=='4'){
          this._getCollectRecordList(values)
        }else if(tableKey=='5'){
          this._getReadRecordList(values)
        }
      },
    }
    return (
      <WizSpin key={'tab_' + tableKey} tip={'加载中'} spinning={proKnowledgeRecordLoading || commentLoading}>
        <div className='pagination'>
          <WizSearchBar key={"record_searchBar"+ this.state.time} type="grid" {...searchBarProps} />
        </div>
        {/* {this.getBtn()} */}
        {this._renderBtn()}
        <WizDataTable key={'record_dataTable'} {...dataTableProps} />
        <div className='pagination'>
          <WizDataTable.Pagination key={'record_pagination'} {...dataTableProps} />
        </div>
      </WizSpin>
    )
  }

  _getDealerInfo() {
    let record = this.knowledgeInfo
    let content = <WizCard title={'知识信息'} bodyStyle={{ paddingLeft: 20, paddingBottom: 25, paddingTop: 25 }}>
      <WizRow>
        <WizCol span={8} offset={1}>
          标题: {record.title}
        </WizCol>
        <WizCol span={7}>
          分类: {record.categoryStr}
        </WizCol>
        <WizCol span={8}>
          标签: {record.labelStr}
        </WizCol>
      </WizRow>
      <WizRow style={{ marginTop: 20 }}>
        <WizCol span={8} offset={1}>
          生效时间: {formatterDate(record.effectiveTime)}
        </WizCol>
        <WizCol span={7}>
          失效时间: {formatterDate(record.failureTime)}
        </WizCol>
        <WizCol span={8}>
          发布平台: {record.releasePlatformStr}
        </WizCol>
      </WizRow>
    </WizCard>
    return content;
  }

  /**回复模态框 */
  replyModal() {
    return (
      <WizModal
        visible={this.state.replyModalVisible}
        onCancel={() => this.setState({ replyModalVisible: false })}
        onOk={() => this._commentAdd()}
        style={{ minWidth: 600 }}
        title={'评论内容'}
        key={this.state.commentId}
      >
        <TextArea maxLength={500} rows={4} placeholder="请输入评论内容,长度限制500字" onChange={(e)=>{this.setState({content: e.target.value})}}/>
      </WizModal>
    )
  }

  _render() {
    return (
      <>
        {this._getDealerInfo()}
        <WizCard title={'记录管理'}>
          <WizTabs activeKey={this.state.knowledgeActivityKey} animated={false} onChange={this.changeTab}>
            <TabPane tab="阅读记录" key="1">
              {this.renderRecordList()}
            </TabPane>
            <TabPane tab="点赞记录" key="2">
              {this.renderRecordList()}
            </TabPane>
            <TabPane tab="评论记录" key="3">
            {this.renderRecordList()}
            </TabPane>
            <TabPane tab="收藏记录" key="4">
            {this.renderRecordList()}
            </TabPane>
            <TabPane tab="下载记录" key="5">
              {this.renderRecordList()}
            </TabPane>
            {this.replyModal()}
          </WizTabs>
        </WizCard>

      </>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { proKnowledgeRecord,comment } = state
  const { history } = ownProps
  const proKnowledgeRecordRead = modelUtils.getModelEntity(proKnowledgeRecord, "proKnowledgeRecord@pageList1")
  const proKnowledgeRecordLike = modelUtils.getModelEntity(proKnowledgeRecord, "proKnowledgeRecord@pageList2")
  const proKnowledgeRecordDownLoad = modelUtils.getModelEntity(proKnowledgeRecord, "proKnowledgeRecord@pageList3")

  const proKnowledgeRecordReadExport = modelUtils.getModelEntity(proKnowledgeRecord, "proKnowledgeRecord@export1")
  const proKnowledgeRecordLikeExport = modelUtils.getModelEntity(proKnowledgeRecord, "proKnowledgeRecord@export2")
  const proKnowledgeRecordDownLoadExport = modelUtils.getModelEntity(proKnowledgeRecord, "proKnowledgeRecord@export3")
  
  const readExportUserIdentity = modelUtils.getModelEntity(proKnowledgeRecord, "proKnowledgeRecord@exportByUserIdentity1")
  const likeExportUserIdentity = modelUtils.getModelEntity(proKnowledgeRecord, "proKnowledgeRecord@exportByUserIdentity2")
  const downLoadExportUserIdentity = modelUtils.getModelEntity(proKnowledgeRecord, "proKnowledgeRecord@exportByUserIdentity3")

  const collectPageList = modelUtils.getModelEntity(proKnowledgeRecord, "proKnowledgeRecord@collectPageList")
  const collectExport = modelUtils.getModelEntity(proKnowledgeRecord, "proKnowledgeRecord@collectExport")
  const collectExportByUserIdentity = modelUtils.getModelEntity(proKnowledgeRecord, "proKnowledgeRecord@collectExportByUserIdentity")

  const commentPageList = modelUtils.getModelEntity(proKnowledgeRecord, "proKnowledgeRecord@commentPageList")
  const commentExport = modelUtils.getModelEntity(proKnowledgeRecord, "proKnowledgeRecord@commentExport")
  const commentExportByUserIdentity = modelUtils.getModelEntity(proKnowledgeRecord, "proKnowledgeRecord@commentExportByUserIdentity")

  const changeTop = modelUtils.getModelEntity(comment, "comment@changeTop")
  const changeScreen = modelUtils.getModelEntity(comment, "comment@changeScreen")
  const commentAdd = modelUtils.getModelEntity(comment, "comment@commentAdd")

  const load = modelUtils.getLoadingState(state, ['proKnowledgeRecord','comment']);
  return {
    proKnowledgeRecordRead,
    proKnowledgeRecordLike,
    proKnowledgeRecordDownLoad,
    proKnowledgeRecordReadExport,
    proKnowledgeRecordLikeExport,
    proKnowledgeRecordDownLoadExport,
    readExportUserIdentity,
    likeExportUserIdentity,
    downLoadExportUserIdentity,
    collectPageList,
    collectExport,
    collectExportByUserIdentity,
    commentPageList,
    commentExport,
    commentExportByUserIdentity,
    changeTop,
    changeScreen,
    commentAdd,
    ...load
  }
}

export default connect(mapStateToProps)(KnowledgeRecodList)
